import dynamic from "next/dynamic";

const FilterTogglersWrapper = dynamic(() => import(/* webpackChunkName: "filter-toggler" */"./FilterTogglersWrapper"), {
  ssr: false,
});

function FilterTogglersLoader(props: any) {
  const { productList, currentPage } = props;
  const totalPages = Math.ceil(productList.totalHits / 12);
  if (currentPage === totalPages || productList.totalHits === 0) {
    return (
      <FilterTogglersWrapper
        {...props}
      />
    );
  }
  return <span />;
}

export default FilterTogglersLoader;
